import React from 'react';
import c from 'classnames';
import { useParallax } from 'react-scroll-parallax';

import { IS_CLIENT } from '../../config/constants';

import './style.scss';

export interface ParallaxIllustrationsProps {
  elementClassName?: string;
}

const PARALLAX_SPEED = 20;

const ParallaxIllustrationsLazy: React.FC<ParallaxIllustrationsProps> = (props) => {
  const { elementClassName } = props;

  const parallaxLeft = useParallax<HTMLDivElement>({ speed: PARALLAX_SPEED });
  const parallaxRight = useParallax<HTMLDivElement>({ speed: PARALLAX_SPEED });

  const classNames = c('ParallaxIllustrations', 'container HomePage__parallax');
  const elementClassNames = c('ParallaxIllustrations__element', elementClassName);

  return (
    <div className={classNames}>
      <div ref={parallaxLeft.ref} className={`${elementClassNames} left`} />
      <div ref={parallaxRight.ref} className={`${elementClassNames} right`} />
    </div>
  );
};

// react-scroll-parallax does not work properly with SSR, so only render client-side.
const ParallaxIllustrations: React.FC<ParallaxIllustrationsProps> = (props) => {
  if (IS_CLIENT) {
    return <ParallaxIllustrationsLazy {...props} />;
  }

  return <div />;
};

export default ParallaxIllustrations;
